import React from 'react';
import { 
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
} from '@mui/material';
import { TextFields as TextFieldsIcon } from '@mui/icons-material';

function AddTextDialog({ open, onClose, formData, formErrors, isAdding, onChange, onSubmit }) {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <TextFieldsIcon />
        Create Text
      </DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 1 }}>
          <TextField
            fullWidth
            label="Text Name"
            value={formData.name}
            onChange={onChange('name')}
            placeholder="Enter text document name"
            error={!!formErrors.name}
            helperText={formErrors.name}
            sx={{ mb: 3 }}
            disabled={!!formData.fromTemplateKey}
          />
          <TextField
            fullWidth
            label="Text Content"
            value={formData.text}
            onChange={onChange('text')}
            placeholder="Enter your text content here..."
            multiline
            rows={6}
            error={!!formErrors.text}
            helperText={formErrors.text}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button 
          onClick={onSubmit} 
          variant="contained"
          disabled={isAdding}
          sx={{
            backgroundColor: '#374151',
            color: '#ffffff',
            '&:hover': { 
              backgroundColor: '#1f2937'
            }
          }}
        >
          {isAdding ? 'Creating...' : 'Create Text'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddTextDialog;
